export default "__VITE_ASSET__DfCsY_YC__"